<template>
    <div :class="['input-wrapper', 'form-input-textarea', { 'input-has-full-border': fullBorder, 'input-wrapper-mb-2x': marginBottomDouble, 'is-required': required }]">
        <label v-if="label" :for="name" :class="{ 'float-label-active': isFloatLabelActive, 'is-float-label': !withoutFloatLabel }">{{ label }}<span v-if="required">*</span></label>
        <textarea
            :id="name"
            ref="textarea"
            v-model="message"
            :class="{
                'required-input': required,
                'input-error-border': hasError,
                'full-border': fullBorder,
                'basic-border': !fullBorder
            }"
            :name="name"
            :placeholder="placeholder ? placeholder : label"
            :maxlength="maxlength ? maxlength : null"
            :required="required"
            @focus="activateFloatLabel"
            @blur="deactivateFloatLabel"
        ></textarea>

        <form-input-error v-if="hasError" :error="errors[0]"></form-input-error>
        <form-input-note v-else-if="note" :text="note"></form-input-note>
    </div>
</template>

<script>
export default {
    props: {
        errors: {
            type: Array,
            required: false,
            default: null
        },
        name: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: false,
            default: null
        },
        placeholder: {
            type: String,
            required: false,
            default: ''
        },
        required: {
            type: Boolean,
            required: false,
            default: false
        },
        autoGrow: {
            type: Boolean,
            required: false,
            default: false
        },
        fullBorder: {
            type: Boolean,
            required: false,
            default: false
        },
        note: {
            type: String,
            required: false,
            default: null
        },
        value: {
            type: String,
            required: false,
            default: ''
        },
        marginBottomDouble: {
            type: Boolean,
            required: false,
            default: false
        },
        maxlength: {
            type: Number,
            required: false
        },
        withoutFloatLabel: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            message: this.value != null ? this.value : '',
            minHeight: 30,
            hasError: false,
            isFloatLabelActive: false
        }
    },

    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.message = value
            }
        },

        message: {
            immediate: true,
            handler(message) {
                if (this.autoGrow) {
                    const textarea = this.$refs.textarea

                    setTimeout(() => {
                        if (textarea) {
                            if (message === '') {
                                textarea.style.height = this.minHeight + 'px'
                            } else {
                                textarea.style.height = textarea.scrollHeight + 'px'
                                textarea.style.overflow = 'hidden'
                            }
                        }

                        if (this.maxlength > 0 && message.length === this.maxlength) {
                            this.errors[0] = lang.get('You have reached the maximum number of characters.')
                        }
                    }, 10)
                }

                if (message) {
                    this.hasError = false
                    this.isFloatLabelActive = true
                }

                this.$emit('input', message)
            }
        },

        errors: {
            immediate: true,
            handler(errors) {
                if (errors === null || errors === undefined || errors.length === 0) {
                    this.hasError = false
                } else {
                    this.hasError = true
                }
            }
        }
    },

    mounted() {
        const textarea = this.$refs.textarea
        textarea.style.height = textarea.scrollHeight + 'px'
    },

    methods: {
        activateFloatLabel() {
            this.isFloatLabelActive = true
        },

        deactivateFloatLabel() {
            if(this.message.length === 0) {
                this.isFloatLabelActive = false
            }
        }
    }
}
</script>
